import { FormTemplate } from "components/modal/templates";
import React from "react";
import { createByRegistry } from "sources/books/universalTransferDocuments";
import { config, initialState } from "./config";

class CreateRegistryUniversalTransferDocumentForm extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    render = () => this.renderBody();

    sendRequest = (stateData = this.state) => {
        return createByRegistry({
            registryId: this.props.id,
            classificationTypeId: stateData.classificationTypeId,
            type: stateData.type,
        });
    };

    renderBodyInner = () => {
        const { type, classificationTypeId } = this.props.config;
        return (
            <>
                {this.renderSelect(type)}
                {this.renderSelect(classificationTypeId)}
            </>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Создать УПД" />;
    };
}

export default function ConfiguredCreateRegistryUniversalTransferDocumentForm(props) {
    return <CreateRegistryUniversalTransferDocumentForm {...props} config={config} initialState={initialState} />;
}
